import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { fetch } from "../../actions";
import { ModalPadrao, LabelPadrao, InputPadrao, LoadingContainerPadrao, ObsIcon } from "../../components/Base";
import * as api from "../Balcao/api";
import { useFetch } from "../../components/Hooks/Conexao";
import TabelaPadrao from "../../components/TabelaPadrao";
import { BtnPadrao, BtnSair } from "../../components/Buttons";
import toLocale from "../../Utils/ToLocaleString";
import { Divider, Tooltip } from "antd";
import culture from "../../Utils/Culture";
import ModalSinalPreVenda from "../Venda/ModalSinalPreVenda";

function RecuperarDetalhe({ id, onOk, onCancel, ...props }) {
  const [sinalDetalhe, setSinalDetalhe] = useState(null);
  const [dados, listarDados, loadingDados] = useFetch(() => api.getById(props.fetch, id));
  useEffect(() => { if (id) listarDados(); }, [id]);

  return <ModalPadrao
    title="Pré-venda"
    visible={id}
    width={window.innerWidth < 1000 ? window.innerWidth : 1000}
    onCancel={onCancel}
    footer={<>
      <BtnPadrao onClick={() => setSinalDetalhe(id)}>Adicionar sinal</BtnPadrao>
      <BtnSair onClick={onCancel} />
    </>}>
    <LoadingContainerPadrao loading={loadingDados} style={{ minHeight: 500 }}>
      {dados && <RecuperarDetalheDados dados={dados} />}
    </LoadingContainerPadrao>

    <ModalSinalPreVenda id={sinalDetalhe} onCancel={() => setSinalDetalhe(null)} onOk={() => { setSinalDetalhe(null); onCancel(); }} />
  </ModalPadrao>;
}

export function RecuperarDetalheDados({ dados }) {

  return <>
    <div style={{ display: "flex", width: "100%" }}>
      <div style={{ width: "40%" }}>
        <LabelPadrao noMargin>Vendedor</LabelPadrao>
        <InputPadrao value={dados.vendedor} disabled />
      </div>
      <div style={{ width: "20%", margin: "0 10px" }}>
        <LabelPadrao noMargin>Número</LabelPadrao>
        <InputPadrao value={dados?.numero} disabled />
      </div>
      <div style={{ width: "40%" }}>
        <LabelPadrao noMargin>Cliente</LabelPadrao>
        <InputPadrao value={dados.cliente} disabled />
      </div>
    </div>

    {!!dados.produtos.length && <>
      <Divider orientation="left">Produtos</Divider>
      <TabelaPadrao ghost columns={columns} data={dados.produtos} />
    </>}

    {!!dados.servicos.length && <>
      <Divider orientation="left">Serviços</Divider>
      <TabelaPadrao ghost columns={columnsServ} data={dados.servicos} />
    </>}

    <Divider orientation="left">Pagamentos</Divider>
    <TabelaPadrao ghost columns={columnsDetPgto} data={dados.pagamentos} />
  </>;
}

export default connect(null, { fetch })(RecuperarDetalhe);

const columns = [
  {
    Header: "Código",
    accessor: "codigo",
    Footer: " ",
  },
  {
    Header: "Descrição",
    accessor: "descricao",
    Cell: props => <div>
      <span>{props.row.original.descricao}</span>
      {!!props.row.original?.obs && <Tooltip placement="bottom" title={props.row.original.obs}>
        <ObsIcon style={{ fontSize: 15, marginLeft: 5 }} />
      </Tooltip>}
    </div>,
  },
  {
    Header: "Quantidade",
    accessor: "qtd",
    Cell: props => <div >
      <span>{culture.format(props.row.original?.qtdPaga)}</span>
      {!!props.row.original?.qtdExtra && <Tooltip placement="right" title="Quantidade extra">
        <span style={{ padding: 5, fontSize: "0.9em" }}>({culture.format(props.row.original?.qtdExtra)})</span>
      </Tooltip>}
    </div>,
    tipo: "right",
    SomarQtd: true,
  },
  {
    Header: "Valor Un.",
    accessor: "valorUn",
    tipo: "rs",
  },
  {
    Header: "Desconto",
    accessor: "desconto",
    tipo: "rs",
    Somar: true,
  },
  {
    Header: "Acréscimo",
    accessor: "acrescimo",
    tipo: "rs",
    Somar: true,
  },
  {
    Header: "Frete",
    accessor: "valorFrete",
    tipo: "rs",
    Somar: true,
  },
  {
    Header: "Total líquido",
    accessor: "valorTotal",
    tipo: "rs",
    Somar: true,
  },
];

const columnsServ = [
  {
    Header: "Código",
    accessor: "codigo",
    Footer: " ",
  },
  {
    Header: "Descrição",
    accessor: "descricao",
    Cell: props => <div>
      <span>{props.row.original.descricao}</span>
      {!!props.row.original?.obs && <Tooltip placement="bottom" title={props.row.original.obs}>
        <ObsIcon style={{ fontSize: 15, marginLeft: 5 }} />
      </Tooltip>}
    </div>,
  },
  {
    Header: "Prestador de serviço",
    accessor: "prestador",
  },
  {
    Header: "Quantidade",
    accessor: "qtd",
    tipo: "dec",
    SomarQtd: true,
  },
  {
    Header: "Valor Un.",
    accessor: "valorUn",
    tipo: "rs",
  },
  {
    Header: "Desconto",
    accessor: "desconto",
    tipo: "rs",
    Somar: true,
  },
  {
    Header: "Acréscimo",
    accessor: "acrescimo",
    tipo: "rs",
    Somar: true,
  },
  {
    Header: "Total líquido",
    accessor: "valorTotal",
    tipo: "rs",
    Somar: true,
  },
];

const columnsDetPgto = [
  {
    Header: "Modalidade",
    accessor: "nome",
    Footer: " ",
  },
  {
    Header: "Troco",
    accessor: "troco",
    Cell: props => (props.row.original.tipo == "troco" && props.row.original.troco > 0) ? <span >{props.row.original.troco && toLocale(props.row.original.troco)} <span style={{ opacity: 0.5, marginLeft: 10 }}>({toLocale(props.row.original.recebido)})</span></span> : <></>,
  },
  {
    Header: "Valor total",
    accessor: "valor",
    tipo: "rs",
    Somar: true,
  },
];